<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-fbaShipment',
  components: {
    PageTable,
  },
}
</script>